import React, {useState, useEffect, useRef} from 'react';
import ChapterBox from "./ChapterBox";
import {
    Box,
    Button,
    AppBar,
    Toolbar,
    Grid,
    Typography,
    Modal,
    LinearProgress,
    TextField,
    MenuItem, Select, Checkbox, FormControlLabel
} from '@mui/material';
import {Slide, Link, LinkEdit, HotEdit, Hot, TopEdit, Top} from '../services/types'
import {
    addSlideToHot,
    addSlideToLink,
    createLink,
    fetchProducts,
    getLink,
    getSlide, refreshSlide,
    updateLink,
    updateSlideHtml
} from '../services/api'
import LinkEditModal from './LinkEditModal';
import HotEditModal from './HotEditModal';
import TopEditModal from './TopEditModal';
import AudioTimeline from './AudioTimeline';
import SingleRecordingEditor from "./SingleRecordingEditor";

interface SlideImage {
    id: string;
    url: string;
}

interface AudioTrack {
    id: string;
    start: number;
    duration: number;
    audioUrl: string;
}
interface Product {
    id: string;
    name: string;
    image_url: string;
}
const SlideEditModal: React.FC<{
    slide: Slide | null;
    isOpen: boolean;
    onClose: () => void;
    onSave: (updatedSlide: Slide) => void;
    presentationType: string;
}> = ({slide, isOpen, onClose, onSave, presentationType}) => {
    const [title, setTitle] = useState(slide?.title || '');
    const [description, setDescription] = useState(slide?.description || '');
    const [duration, setDuration] = useState(slide?.duration || 0);
    const [externalId, setExternalId] = useState(slide?.external_id || '');
    const [isLinkEditModalOpen, setIsLinkEditModalOpen] = useState(false);
    const [isHotEditModalOpen, setIsHotEditModalOpen] = useState(false);
    const [isTopEditModalOpen, setIsTopEditModalOpen] = useState(false);
    const [editingLink, setEditingLink] = useState<LinkEdit | null>(null);
    const [editingHot, setEditingHot] = useState<string>("");
    const [editingTop, setEditingTop] = useState<string>("");
    const [editingSlideId, setEditingSlideId] = useState<string | null>(null);
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const [currentSlide, setCurrentSlide] = useState<Slide | null>(null)
    const [category, setCategory] = useState<string | "brands">("brands")
    const [audioTracks, setAudioTracks] = useState<AudioTrack[]>([]);
    const [products, setProducts] = useState<Product[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<string>('');
    const [slideDetailing, setSlideDetailing] = useState<boolean>(false);
    const [recordVideoOpen, setRecordVideoOpen] = useState<boolean>(false);

    const fetchSlideData = async () => {
        try {
            const data = await getSlide(slide!.id);
            setCurrentSlide(data)
            setCategory(slide!.category)
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
        }
    };

    const fetchProductsData = async () => {
        try {
            const data = await fetchProducts(1);
            setProducts(data.items);
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
        }
    };

    useEffect(() => {
        fetchProductsData();
        fetchSlideData();
    }, [slide]);


    const handleLinkClick = (link: Link | null, slideId: string) => {
        setEditingLink(link);
        setEditingHot(slideId);
        setEditingSlideId(slideId);
        setIsLinkEditModalOpen(true);
    };

    useEffect(() => {
        if (slide) {
            setTitle(slide.title || '');
            setDescription(slide.description || '');
            setDuration(slide.duration || 60);
            setExternalId(slide.external_id || '');
            setSelectedProduct(slide.product_id);
            setSlideDetailing(slide.detailing);
            if (slide.detailing === null){
                setSlideDetailing(false);
            }
        }
    }, [slide]);

    const handleSave = () => {
        if (slide) {
            onSave({...slide, title, description, duration, external_id: externalId, category, detailing: slideDetailing, product_id: selectedProduct});
            setDuration(duration)
        }
        // onClose();
    };

    const handleRefreshSlide = async () => {
        await refreshSlide(slide!.id)
        fetchSlideData()
    };

    useEffect(() => {
        const handleMessage = async (event: MessageEvent) => {
            if (event.data === '') {
                // try {
                //     const response = await createLink({
                //         name: '',
                //         link_type: 'popup',
                //         url: '',
                //         slide_id: slide?.id
                //     });
                //     const newLinkId = response.id;
                //     window.frames[0].postMessage({ action: 'setLinkId', linkId: newLinkId.id }, '*');
                //     handleLinkClick(newLinkId, slide!.id)
                // } catch (error) {
                //     console.error('Error creating link:', error);
                //     console.log('Error creating link');
                // }
                handleLinkClick(null, slide!.id)

            } else if (event.data === "undefined"){
                handleLinkClick(null, slide!.id)
            } else if (event.data === "done"){
                if (iframeRef.current) {
                    const iframeDocument = iframeRef.current.contentDocument ||
                        iframeRef.current.contentWindow?.document;
                    // console.log(iframeDocument)
                    if (iframeDocument) {
                        const iframeHtml = iframeDocument.documentElement.outerHTML;
                        // console.log(iframeHtml);
                        var newHtml = {
                            html: iframeHtml
                        }
                        await updateSlideHtml(slide?.id as string, newHtml)
                    }
                }
            } else {
                try {
                    const response = await getLink(event.data);
                    handleLinkClick(response, slide!.id)
                } catch (error) {
                    // @ts-ignore
                    // console.error('Error checking link:', error?.status);
                    // const response = await createLink({
                    //     name: '',
                    //     link_type: 'popup',
                    //     url: '',
                    //     slide_id: slide?.id
                    // });
                    // const newLinkId = response;
                    // window.frames[0].postMessage({ action: 'setLinkId', linkId: newLinkId.id }, '*');
                    // handleLinkClick(newLinkId, slide!.id)
                    handleLinkClick(null, slide!.id)
                }
            }
        };


        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [slide]);

    const handleSaveLink = async (linkdData: LinkEdit | null, slideImages: SlideImage[]) => {
        setIsLinkEditModalOpen(false)

        // console.log("==="+ linkdData?.id)
        if (linkdData?.id == null){
            const response = await createLink({
                name: '',
                link_type: linkdData?.link_type as string,
                url: linkdData?.url as string,
                slide_id: slide?.id
            });
            const newLinkId = response.id;
            // console.log(newLinkId)
            window.frames[0].postMessage({ action: 'setLinkId', linkId: newLinkId }, '*');


            if (linkdData?.link_type === 'popup' || linkdData?.link_type === 'multipopup' || linkdData?.link_type === 'direction' || linkdData?.link_type === 'multidirection') {
                var slide_images: string[] = [];
                slideImages.forEach(img => {
                    slide_images.push(img.id)
                });
                await addSlideToLink(newLinkId, slide_images)
            }
        }else{
            if (linkdData?.link_type === 'popup' || linkdData?.link_type === 'multipopup' || linkdData?.link_type === 'direction' || linkdData?.link_type === 'multidirection') {
                var slide_images: string[] = [];
                slideImages.forEach(img => {
                    slide_images.push(img.id)
                });
                await addSlideToLink(linkdData?.id, slide_images)
            }
            const linkDataVal: Link = {
                id: linkdData?.id,
                link_type: linkdData?.link_type as string,
                name: '',
                url: linkdData.url,
                slide_id: linkdData.slide_id
            };
            await updateLink(linkdData?.id, linkDataVal);
            // handleLinkClick(linkdData as Link, slide!.id)
        }


    }


    const handleSaveHot = async (hotdData: HotEdit | null, slideImages: SlideImage[]) => {
        setIsHotEditModalOpen(false)

        // await addSlideToHot(newLinkId, slide_images[0])

        // console.log("==="+ linkdData?.id)
        // if (linkdData?.id == null){
        //     const response = await createLink({
        //         name: '',
        //         link_type: linkdData?.link_type as string,
        //         url: linkdData?.url as string,
        //         slide_id: slide?.id
        //     });
        //     const newLinkId = response.id;
        //     // console.log(newLinkId)
        //     window.frames[0].postMessage({ action: 'setLinkId', linkId: newLinkId }, '*');
        //
        //
        //     if (linkdData?.link_type === 'popup' || linkdData?.link_type === 'direction') {
        //         var slide_images: string[] = [];
        //         slideImages.forEach(img => {
        //             slide_images.push(img.id)
        //         });
        //         await addSlideToLink(newLinkId, slide_images)
        //     }
        // }else{
        //     if (linkdData?.link_type === 'popup' || linkdData?.link_type === 'direction') {
        //         var slide_images: string[] = [];
        //         slideImages.forEach(img => {
        //             slide_images.push(img.id)
        //         });
        //         await addSlideToLink(linkdData?.id, slide_images)
        //     }
        //     const linkDataVal: Link = {
        //         id: linkdData?.id,
        //         link_type: linkdData?.link_type as string,
        //         name: '',
        //         url: linkdData.url,
        //         slide_id: linkdData.slide_id
        //     };
        //     await updateLink(linkdData?.id, linkDataVal);
        //     // handleLinkClick(linkdData as Link, slide!.id)
        // }


    }
    const handleSaveTop = async (topdData: TopEdit | null, slideImages: SlideImage[]) => {
        setIsHotEditModalOpen(false)
    }
    // const handleSave = () => {
    //     // ... другой код сохранения
    //     const tracksData = audioTracks.map(track => ({
    //         id: track.id,
    //         start: track.start,
    //         duration: track.duration
    //     }));
    //     // Отправка tracksData на сервер
    // };
    return (
        <Box>
            {/*<Box sx={{width: 'calc(100% - 348px)', height: 'calc(100% - 240px)', position: 'absolute'}}>*/}
            <Box sx={{width: 'calc(100% - 348px)', height: '100%', position: 'absolute'}}>
                <iframe
                    ref={iframeRef}
                    srcDoc={currentSlide?.html}
                    style={{ width: '100%', border: 'none', height: '100%', background: '#fff' }}
                    title={slide?.name}
                />
                {/*<AudioTimeline*/}
                {/*    slideId={slide!.id}*/}
                {/*    duration={duration || 60} // Длительность слайда в секундах*/}
                {/*    onTracksChange={setAudioTracks}*/}
                {/*/>*/}
                {/*<iframe*/}
                {/*    src={`https://static.productscript.ru/uploads/archives/${slide?.project_id}/source_edit/${slide?.name}.html`}*/}
                {/*    style={{ width: '100%', border: 'none', height: '100%', background: '#fff' }}*/}
                {/*    title={slide?.name}*/}
                {/*/>*/}
            </Box>
            <Box className='slideInfoEdit'>

                <TextField
                    fullWidth
                    margin="normal"
                    label="Название"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    multiline
                    rows={1}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Описание"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    multiline
                    rows={4}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Длительность (секунд)"
                    type="number"
                    value={duration}
                    onChange={(e) => setDuration(Number(e.target.value))}
                />
                {presentationType === '311582a1-4e73-46d2-acf0-931505871772' && (
                    <>
                        <TextField
                            fullWidth
                            margin="normal"
                            label="ELMA ID"
                            value={externalId}
                            onChange={(e) => setExternalId(e.target.value)}
                        />
                        <Select
                            value={category}
                            onChange={(e) => {setCategory(e.target.value);}}
                            fullWidth
                            margin="none"
                        >
                            <MenuItem value="patient_profiles">Patient profiles</MenuItem>
                            <MenuItem value="others">Other</MenuItem>
                            <MenuItem value="brands">Brands</MenuItem>
                            <MenuItem value="opening">Opening</MenuItem>
                            <MenuItem value="closing">Closing</MenuItem>
                        </Select>

                        <Select
                            sx={{mt: 1}}
                            fullWidth
                            value={selectedProduct || ''}
                            onChange={(e) => setSelectedProduct(e.target.value)}
                        >
                            {products.map((product) => (
                                <MenuItem key={product.id} value={product.id}>
                                    {product.name}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormControlLabel className='premissionCheck'
                          control={<Checkbox checked={slideDetailing} onChange={()=>setSlideDetailing(!slideDetailing)} />}
                          label="Убрать&nbsp;детализацию"
                        />
                    </>

                )}

                <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                    <Button onClick={handleSave} variant="contained" sx={{mt: 2, background:'#3a485b'}}>
                        Сохранить
                    </Button>
                    <Button onClick={onClose} variant="contained" sx={{mt: 2, background:'rgba(58,72,91,0.09)'}}>
                        Закрыть
                    </Button>
                </Box>
                <Button onClick={()=>setIsHotEditModalOpen(true)} variant="contained" sx={{mt: 2, width: "100%", background:' rgba(255, 0, 0, 1)'}}>
                    Горячие слайды
                </Button>
                <Button onClick={()=>setIsTopEditModalOpen(true)} variant="contained" sx={{mt: 2, width: "100%", background:' #ad00ff'}}>
                    Слайды сверху
                </Button>
                {/*<Box sx={{display: 'flex'}}>*/}
                {/*    <Button onClick={() => setRecordVideoOpen(true)} variant="contained" sx={{mt: 2, width: "100%", background:'#3a485b'}}>*/}
                {/*        Записать видео*/}
                {/*    </Button>*/}
                {/*    <a href={"https://static.productscript.ru/uploads/webm/audio_"+slide?.id+".webm.mp4"} target="_blank">*/}
                {/*        <Button variant="contained" sx={{mt: 2, width: "100%", background:'#1b6448'}}>*/}
                {/*            Открыть*/}
                {/*        </Button>*/}
                {/*    </a>*/}
                {/*</Box>*/}
                <Button onClick={handleRefreshSlide} variant="contained" sx={{mt: 2, left: '24px', width: "calc(100% - 48px)", position: 'absolute', bottom: '24px'}}>
                    Обноваить код слайда
                </Button>

            </Box>

            {isLinkEditModalOpen ?
                <LinkEditModal
                    isOpen={isLinkEditModalOpen}
                    onClose={() => setIsLinkEditModalOpen(false)}
                    onSaveLink={(linkdData: LinkEdit | null, slideImages: SlideImage[]) => handleSaveLink(linkdData, slideImages)}
                    link={editingLink as Link}
                    slideId={slide!.id}
                    projectId={slide!.project_id}
                />
                : null }

            {isHotEditModalOpen ?
                <HotEditModal
                    isOpen={isHotEditModalOpen}
                    onClose={() => setIsHotEditModalOpen(false)}
                    onSaveHot={(hotData: TopEdit | null, slideImages: SlideImage[]) => handleSaveTop(hotData, slideImages)}
                    hot={slide!.id}
                    slideId={slide!.id}
                    projectId={slide!.project_id}
                />
                : null }

            {isTopEditModalOpen ?
                <TopEditModal
                    isOpen={isTopEditModalOpen}
                    onClose={() => setIsTopEditModalOpen(false)}
                    onSaveTop={(topData: TopEdit | null, slideImages: SlideImage[]) => handleSaveTop(topData, slideImages)}
                    top={slide!.id}
                    slideId={slide!.id}
                    projectId={slide!.project_id}
                />
                : null }

            {recordVideoOpen && (
                <SingleRecordingEditor slide={slide!} closeRecording={() => setRecordVideoOpen(false)} />
            )}
        </Box>
    );
};
export default SlideEditModal;
